import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f8d48930"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "active-txs w-full max-w-lg"
}
const _hoisted_2 = { class: "flex flex-row items-center p-2 mb-3 justify-between" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Nomad Transaction History ")
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "flex flex-row justify-between items-center" }
const _hoisted_6 = { class: "flex flex-row items-center justify-between" }
const _hoisted_7 = { class: "flex flex-row" }
const _hoisted_8 = { class: "opacity-70 uppercase" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_text = _resolveComponent("n-text")!
  const _component_transaction = _resolveComponent("transaction")!
  const _component_amount = _resolveComponent("amount")!
  const _component_n_divider = _resolveComponent("n-divider")!
  const _component_chevron_back_outline = _resolveComponent("chevron-back-outline")!
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_chevron_forward_outline = _resolveComponent("chevron-forward-outline")!

  return (this.history.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_n_text, { class: "uppercase text-lg font-semibold" }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1 /* STABLE */
          }),
          _createCommentVNode(" <n-text class=\"opacity-70 text-lg\">{{ history.length }}</n-text> ")
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.history, (tx) => {
          return (_openBlock(), _createElementBlock("div", {
            key: tx,
            onClick: ($event: any) => (_ctx.toTx(tx)),
            class: "cursor-pointer"
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_transaction, { tx: tx }, null, 8 /* PROPS */, ["tx"]),
              _createVNode(_component_amount, { tx: tx }, null, 8 /* PROPS */, ["tx"])
            ]),
            _createVNode(_component_n_divider)
          ], 8 /* PROPS */, _hoisted_4))
        }), 128 /* KEYED_FRAGMENT */)),
        _createCommentVNode(" pagination "),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changePage(_ctx.page - 1))),
              class: _normalizeClass(["bg-[#434343] h-8 w-8 mr-2 flex items-center justify-center rounded-sm cursor-pointer", { 'opacity-50': _ctx.page === 1 }])
            }, [
              _createVNode(_component_n_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_chevron_back_outline)
                ]),
                _: 1 /* STABLE */
              })
            ], 2 /* CLASS */),
            _createElementVNode("div", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changePage(_ctx.page + 1))),
              class: _normalizeClass(["bg-[#434343] h-8 w-8 flex items-center justify-center rounded-sm cursor-pointer", { 'opacity-50': _ctx.page === _ctx.pageCount || _ctx.history.length < _ctx.size }])
            }, [
              _createVNode(_component_n_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_chevron_forward_outline)
                ]),
                _: 1 /* STABLE */
              })
            ], 2 /* CLASS */)
          ]),
          _createElementVNode("div", _hoisted_8, "Page " + _toDisplayString(_ctx.page), 1 /* TEXT */)
        ])
      ]))
    : _createCommentVNode("v-if", true)
}